var _path, _path2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoplaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 140",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 8C60 8 18 52 18 88C18 112.853 36.147 132 60 132C83.853 132 102 112.853 102 88C102 52 60 8 60 8Z",
    fill: "#1a4a8a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28C60 28 34 58 34 84C34 99.464 45.536 112 60 112C74.464 112 86 99.464 86 84C86 58 60 28 60 28Z",
    fill: "#2d6cb5",
    opacity: 0.35
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 98,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 42,
    fontWeight: 700
  }, ".")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoplaceholder);
export default __webpack_public_path__ + "static/media/logo.placeholder.3716291305d3a1293b61d68d4243931f.svg";
export { ForwardRef as ReactComponent };